import React, { useEffect, useState } from 'react';
import { useAsync } from 'react-async-hook';
import { Alert } from 'react-bootstrap/lib';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { RouteComponentProps } from 'react-router-dom';
import { Website } from '@upstart/harmony/lib/legos/websiteTypes';
import {
  TranslationRules as TranslationRulesType,
  TranslationRulesClient,
} from '@upstart/harmony/lib/legos/translationRulesTypes';
import TranslationRulesService from '../../../services/TranslationRulesService';
import Select from '../WebsiteWidgetConfigEditor/inputs/Select';
import websiteActions from '../../../redux/websites/actions';

interface Props extends RouteComponentProps<{}> {
  website?: Website;
  actions: {
    updateWebsiteRequest: ({ website }: { website: Website }) => void;
  };
}

function WebsiteTranslationRules({ actions, history, website }: Props) {
  const [showOverrides, setShowOverrides] = useState(false);
  const [selectedTranslationRulesId, setSelectedTranslationRulesId] = useState<
    string
  >('');
  const allTranslationRules = useAsync<TranslationRulesType[]>(
    TranslationRulesService.getAll,
    [TranslationRulesClient.WEB],
  );

  useEffect(() => {
    if (website?.id) {
      setShowOverrides(!!website.translationRulesId);
      setSelectedTranslationRulesId(website.translationRulesId || '');
    }
  }, [website]);

  if (!website?.id) {
    return null;
  }

  return (
    <div className="website-tab-container">
      <div className="row">
        <div className="field col-sm-12">
          {allTranslationRules.loading && <Alert>Loading...</Alert>}
          <div className="horz-radio-container">
            <label htmlFor="none">
              No Custom TranslationRules
              <input
                type="radio"
                name="method"
                id="none"
                checked={!showOverrides}
                onChange={() => {
                  setShowOverrides(false);
                  setSelectedTranslationRulesId('');
                }}
              />
            </label>
            <label htmlFor="override">
              Use Custom Translation Override Rules
              <input
                type="radio"
                name="method"
                id="override"
                checked={showOverrides}
                onChange={() => setShowOverrides(true)}
              />
            </label>
          </div>
        </div>
        {showOverrides && (
          <div className="field col-sm-12">
            <h3>Select a Custom Translation Rule</h3>
            <Select
              label="Translation Rules"
              name="customTheme"
              value={selectedTranslationRulesId}
              onChange={e => {
                setSelectedTranslationRulesId(e.target.value);
              }}
            >
              <Select.Option value={''} name="None" />
              {allTranslationRules.result?.map(translationRule => (
                <Select.Option
                  key={translationRule.id}
                  value={translationRule.id}
                  name={`${translationRule.name} (ID: ${translationRule.id})`}
                />
              ))}
            </Select>
          </div>
        )}
        {showOverrides && selectedTranslationRulesId && (
          <div className="field col-sm-12 pt-10">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`${process.env.REACT_APP_WEB_URL}/${website.id}?previewTranslationRulesId=${selectedTranslationRulesId}`}
            >
              <Button bsStyle="link">Preview Translation Rules</Button>
            </a>
          </div>
        )}
      </div>
      <div className="row submit-button-row">
        <div>
          <Button
            className="btn btn-secondary"
            type="button"
            onClick={() => history.push('/websites/')}
          >
            Cancel
          </Button>
        </div>
        <div>
          <Button
            className="btn btn-primary"
            type="button"
            onClick={() => {
              actions.updateWebsiteRequest({
                website: {
                  ...website,
                  translationRulesId: selectedTranslationRulesId || null,
                },
              });
            }}
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch: Dispatch<{}>) => ({
  actions: bindActionCreators(
    {
      ...websiteActions,
    },
    dispatch,
  ),
});

export default connect(null, mapDispatchToProps)(WebsiteTranslationRules);
